import { IArrayResponse, IPaginatedResponse, IResponse } from '../../response'

export enum ProductWarrantyClaimStatus {
  Sent = 'sent',
  InProgress = 'inprogress',
  Finalised = 'finalised',
  Rejected = 'rejected'
}

interface FormData {
  CompanyProductDetails: CompanyProductDetails
  WarrantyDetails: WarrantyDetails
  VehicleRelatedProducts: VehicleRelatedProducts
  AgreedToTerms: boolean
}

interface CompanyProductDetails {
  CompanyName: string
  CustomerName: string
  EmailAddress: string
  ArticleNumber: string
  ProductQuantity: number | string
  ItemDescription: string
}

interface WarrantyDetails {
  ContactPerson: string
  PurchaseDate: string
  IsTelephoneContact: boolean
  EmployeeName: string
  TransportDamage: boolean
  DiagnosisCause: string
  ChosenSolution: string
}

interface VehicleRelatedProducts {
  LicensePlate: string
  ChassisNumber: string
  DataDefect: string
  KMReadingAtInstallation: number | string
  KMReadingInCaseOfDefect: number | string
}

export interface AttachmentS3 {
  Key: string
  Name: string
  ContentType: string
  File?: File
}

export interface IProductWarrantyClaim {
  UUID: string
  WholesalerUUID: string
  Status: ProductWarrantyClaimStatus
  Amount: number
  Remark: string
  LicensePlate: string
  FormData: FormData
  AttachmentsS3: AttachmentS3[]
}

export interface IProductWarrantyClaimResponse extends IProductWarrantyClaim {
  CaseNumber: string
  CreatedAt: string
  UpdatedAt: string
}

export type GetProductWarrantyClaimResponse = IResponse<IProductWarrantyClaimResponse>
export type GetProductWarrantyClaimRowsResponse = IArrayResponse<IProductWarrantyClaimResponse>
export type GetProductWarrantyClaimsResponse = IPaginatedResponse<IProductWarrantyClaimResponse>


export const ProductWarrantyClaimIsTelephoneContact = {
  YES: true,
  NO: false
} as const

type ProductWarrantyClaimIsTelephoneContact =
  typeof ProductWarrantyClaimIsTelephoneContact[keyof typeof ProductWarrantyClaimIsTelephoneContact]

export const ProductWarrantyClaimTransportDamage = {
  YES: true,
  NO: false
} as const

export type ProductWarrantyClaimTransportDamage =
  typeof ProductWarrantyClaimTransportDamage[keyof typeof ProductWarrantyClaimTransportDamage]
